import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "button__icon"
}
const _hoisted_2 = {
  key: 1,
  class: "button__inner"
}
const _hoisted_3 = {
  key: 2,
  class: "button__icon"
}

import { computed, ref, useSlots } from "vue";
import { MobileAppMethodName } from "@sazka/mobile-apps/mobile-app-models";
import { DsButtonExpose, DsButtonRefType } from "../button/ds-button-reference";
import DsIcon from "../icon/ds-icon.vue";
import { SvgIcons } from "../icon/types";
import { ButtonType } from "../types/button";
import { Size } from "../types/size";
import { Theme } from "../types/theme";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-button',
  props: {
    tag: { default: "auto" },
    href: {},
    type: { default: "primary" },
    theme: { default: "light" },
    size: { default: "default" },
    isDisabled: { type: Boolean },
    iconLeft: {},
    iconRight: {},
    isInStorybook: { type: Boolean, default: false },
    openInNewTab: { type: Boolean, default: false },
    isExternal: { type: Boolean, default: false },
    isBlock: { type: Boolean, default: false },
    dataTest: {},
    dataTestid: {},
    htmlType: { default: "button" },
    eventName: {},
    eventArgument: {}
  },
  setup(__props: any, { expose: __expose }) {

const slots = useSlots();

const rootElement = ref<DsButtonRefType>(null);

__expose<DsButtonExpose>({
    rootElement,
});

const props = __props;

const mobileAppIntegration: Record<"isMobileApp" | "triggerMobileAppEvent", any> = {
    isMobileApp: null,
    triggerMobileAppEvent: null,
};

if (!props.isInStorybook) {
    import("@sazka/mobile-apps/mobile-app-integration").then(({ isMobileApp, triggerMobileAppEvent }) => {
        mobileAppIntegration["isMobileApp"] = isMobileApp;
        mobileAppIntegration["triggerMobileAppEvent"] = triggerMobileAppEvent;
    });
}

const hrefFormatted = computed(() => props.href?.replace("~", ""));

const tagName = computed(() => {
    if (props.tag === "auto") {
        return hrefFormatted.value ? "a" : "button";
    }
    return props.tag;
});

const classes = computed(() => [
    `button--${props.type}`,
    props.theme === "dark" ? "button--dark" : "",
    props.size !== "default" ? `button--${props.size}` : "",
    props.isDisabled ? "button--disabled" : "",
    props.iconLeft || props.iconRight ? "button--icon" : "",
    props.isBlock ? "button--block" : "",
]);

const attributes = computed(() => {
    const attributes = {
        target: null,
        rel: null,
        disabled: props.isDisabled ? "" : undefined,
        type: null,
    };

    if (tagName.value == "button") {
        attributes.type = props.htmlType;
        return attributes;
    }

    if (props.openInNewTab || props.isExternal) {
        attributes.target = "_blank";
        attributes.rel = "noopener";
    }
    if (props.isExternal) {
        attributes.rel += " noreferrer";
    }

    return attributes;
});

const regexp = /.*-thin/gm;

const getThinIconName = (iconName: SvgIcons): SvgIcons => {
    return regexp.test(iconName) ? iconName : (`${iconName}-thin` as SvgIcons);
};

const getRegularIconName = (iconName: SvgIcons): SvgIcons => {
    return !regexp.test(iconName) ? iconName : (iconName.slice(0, -5) as SvgIcons);
};

const buttonClickHandler = (event: Event) => {
    if (props.isInStorybook) return;

    if (props.isDisabled) {
        event.preventDefault();
    } else if (props.eventName && mobileAppIntegration.isMobileApp) {
        event.preventDefault();
        mobileAppIntegration.triggerMobileAppEvent(props.eventName as string, props.eventArgument);
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(tagName.value), _mergeProps({
    href: hrefFormatted.value,
    class: ["button", classes.value],
    "data-test": _ctx.dataTest,
    "data-testid": _ctx.dataTestid
  }, attributes.value, {
    ref_key: "rootElement",
    ref: rootElement,
    onClick: buttonClickHandler
  }), {
    default: _withCtx(() => [
      (_ctx.iconLeft)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_ctx.size === 'sm')
              ? (_openBlock(), _createBlock(DsIcon, {
                  key: 0,
                  name: getThinIconName(_ctx.iconLeft),
                  "is-in-storybook": _ctx.isInStorybook,
                  width: 16,
                  height: 16
                }, null, 8, ["name", "is-in-storybook"]))
              : (_ctx.size === 'lg')
                ? (_openBlock(), _createBlock(DsIcon, {
                    key: 1,
                    name: getRegularIconName(_ctx.iconLeft),
                    "is-in-storybook": _ctx.isInStorybook,
                    width: 24,
                    height: 24
                  }, null, 8, ["name", "is-in-storybook"]))
                : (_openBlock(), _createBlock(DsIcon, {
                    key: 2,
                    name: _ctx.iconLeft,
                    "is-in-storybook": _ctx.isInStorybook
                  }, null, 8, ["name", "is-in-storybook"]))
          ]))
        : _createCommentVNode("", true),
      (!!_unref(slots).default)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true),
      (_ctx.iconRight)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            (_ctx.size === 'sm')
              ? (_openBlock(), _createBlock(DsIcon, {
                  key: 0,
                  name: getThinIconName(_ctx.iconRight),
                  "is-in-storybook": _ctx.isInStorybook,
                  width: 16,
                  height: 16
                }, null, 8, ["name", "is-in-storybook"]))
              : (_ctx.size === 'lg')
                ? (_openBlock(), _createBlock(DsIcon, {
                    key: 1,
                    name: getRegularIconName(_ctx.iconRight),
                    "is-in-storybook": _ctx.isInStorybook,
                    width: 24,
                    height: 24
                  }, null, 8, ["name", "is-in-storybook"]))
                : (_openBlock(), _createBlock(DsIcon, {
                    key: 2,
                    name: _ctx.iconRight,
                    "is-in-storybook": _ctx.isInStorybook
                  }, null, 8, ["name", "is-in-storybook"]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["href", "class", "data-test", "data-testid"]))
}
}

})